"use client";

import Link from "next/link";
import { User } from "lucide-react";
import { useTranslations } from "next-intl";

import { Button } from "@louez/ui";
import { WrenchIcon } from "@louez/ui/icons";

import { useStorefrontUrl } from "@/hooks/use-storefront-url";

interface StoreHeaderProps {
  storeName: string;
  storeSlug: string;
  logoUrl?: string | null;
}

export function StoreHeader({ storeName, storeSlug, logoUrl }: StoreHeaderProps) {
  const t = useTranslations("storefront.header");
  const { getUrl } = useStorefrontUrl(storeSlug);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 pointer-events-none">
      <div className="container mx-auto flex items-start justify-between px-4 py-4 md:py-6">
        <Link href={getUrl("/")} className="pointer-events-auto">
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={storeName}
              className="h-10 md:h-14 max-w-[200px] object-contain drop-shadow-lg"
            />
          ) : (
            <span className="text-xl md:text-2xl font-bold bg-background/80 backdrop-blur-sm px-3 py-1.5 rounded-lg shadow-sm">
              {storeName}
            </span>
          )}
        </Link>

        <div className="pointer-events-auto flex items-center gap-2">
          <Button
            variant="outline"
            render={<Link href={getUrl("/services")} />}
            className="gap-2 bg-background/90 shadow-lg backdrop-blur-sm"
          >
            <WrenchIcon className="h-4 w-4" />
            <span className="hidden sm:inline">Servicios</span>
          </Button>
          <Button
            render={<Link href={getUrl("/account")} />}
            className="gap-2 shadow-lg"
          >
            <User className="h-4 w-4" />
            <span className="hidden sm:inline">{t("myAccount")}</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
